import { render, staticRenderFns } from "./allienceLive.vue?vue&type=template&id=3bbaf508&scoped=true"
import script from "./allienceLive.vue?vue&type=script&lang=js"
export * from "./allienceLive.vue?vue&type=script&lang=js"
import style0 from "./allienceLive.vue?vue&type=style&index=0&id=3bbaf508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbaf508",
  null
  
)

export default component.exports